// **** this page is not being used ****
// left here as a starting point if OAuth is implemented

// import * as Global from "../common/global";
// import * as AuthenticationData from "../data/authenticationData";
import { IController } from "../interfaces/controller";
// import * as Data from "../interfaces/data";

// This is the page the external OAuth (ADFS) server will redirect too
// after the user has enter valid credentials
export class OAuthLoginController implements IController {
    public render(container: JQuery): JQuery.Promise<any, any, any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        // *** Revisit this code when implementing OAuth

        // const app = Global.app();
        // const oauthLoginManager  = app.oauthLoginManager();
        // const pageManager = app.pageManager();

        // const loginResult = oauthLoginManager.getLoginResult();
        // if (!oauthLoginManager.isLoginResultValid(loginResult)) {
        //     // returned values are not valid
        //     pageManager.closeAllAndGotoDefaultPage();
        // }

        // AuthenticationData.AuthenticateJWT({
        //     IDToken: oauthLoginManager.getIDTokenFromLoginResult(loginResult),
        //     NOnce: oauthLoginManager.getNonce(),
        // }).done((authenticateJWTResult: Data.IResponse<AuthenticationData.IAuthenticationResponse>) => {
        //     if (authenticateJWTResult.Payload.IsAuthenticated) {
        //         // save the user information for use by all other pages
        //         app.loginUser(authenticateJWTResult.Payload.AuthenticationToken, authenticateJWTResult.Payload.UserSession, authenticateJWTResult.Payload.ReportToken);
        //         // goto the correct home page for the user
        //         pageManager.closeAllAndGotoDefaultPage();
        //     } else {
        //         pageManager.closeAllAndGotoDefaultPage();
        //     }
        // }).fail(() => {
        //     pageManager.closeAllAndGotoDefaultPage();
        // });

        deferred.resolve();
        return deferred.promise();
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public appRouterID(params: any[]): string {
        return "OAuthLogin";
    }

    public title(): string {
        return "External Login";
    }

    public subTitle(): string {
        return "";
    }

    public AllowAnonymousAccess(): boolean {
        return true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/oauthLogin.ts